import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalStorage } from "../../../utils/Utils";
import { useApi } from "../../../service/ApiContext";
import { RootState } from "../../../store/store";
import {
  resetToIndustry,
  resetToProgram,
  setActiveTab,
  setSelectedItem,
} from "../data/redux/ProgramAdvanceFilterRedux";
import VideoExportApiCallServices from "../data/api services/VideoExportApiServices";
import { FilterFieldNested, FilterGroup, GradedPopQuizResponse, ProgramList, SubjectList, SubjectResponse } from "../data/interface/AdvancedFilterReponse";
import Logger from "../../../utils/Logger";
import strings from "../../../utils/Strings";
import { useAlert } from "../../../components/AlertContextComponent";
import Loader from "../../../utils/Utils"
import { setSelectedProgram, setSelectedSubject, setSubjects, SubjectOption, toggleSubject } from "../data/redux/GradedPopQuizRedux";
import Form from "react-bootstrap/esm/Form";
import  "../styles/AdvanceFilterForProgram.css";
interface AssessmentItem {
  candidate_id: string;
  assessment_id: string;
  assessment_name: string;
  timestamp: string;
}

interface AdvancedFilterProps {
  onReset: () => void;
 onView: (
    program_id: string | null,
    selectedStatus: boolean | null,
        subjects:any[],

    course_id: string | null,
  ) => void;  selectedItems: any | null;
  setSelectedItems: (item: any) => void;
  heading:string;
setresetGP: React.Dispatch<React.SetStateAction<boolean>>;
}

const AdvancedFilterGradedPopQuiz: React.FC<AdvancedFilterProps> = ({
  onReset,
  onView,
   selectedItems,
  setSelectedItems,
  heading,
  setresetGP=()=>{}
}) => {
  const dispatch = useDispatch();
  const { activeTab,} = useSelector((state: RootState) => state.advancedFilter);
  const { showAlert } = useAlert();
  const setAuthToken = () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
  };
const [selectedProgramId, setSelectedProgramId] = useState<string | null>(null);

  const [industries, setIndustries] = useState<AssessmentItem[]>([]);
const [subjectOptions, setSubjectOptions] = useState<any[]>([]);

  const api = useApi();
const gradedProgram = useSelector((state: RootState) => state.advancedFilterGradedPopQuiz.gradedProgram);
const selectedProgram = useSelector((state: RootState) => state.advancedFilterGradedPopQuiz.selectedProgram);
  const subjects = useSelector((state: RootState) => state.advancedFilterGradedPopQuiz.subjects);
const selectedSubject = useSelector((state: RootState) => state.advancedFilterGradedPopQuiz.selectedSubject);
const profileData = useSelector((state: RootState) => state.profile.profileKeys);

// useEffect(() => {
//   if (profileData.partner_institute != true) {
//     dispatch(setActiveTab("industry"));
//   } 
// }, []);
 
 const { getProgramList, getSubjectList, getTopicsList, getVideosList } =
    VideoExportApiCallServices();
    const [filterFieldsList, setFilterFieldsList] = useState<any[]>(
    []
  );
 
useEffect(() => {Logger.info("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$",gradedProgram); dispatch(setActiveTab(""));});


const onProgramClick = (program: any) => {
  dispatch(setSelectedProgram(program));

  getSubjectList({
    programId: program.program_id, // ✅ DIRECT ACCESS
    onCallBack: (list: SubjectList[]) => {
      if (!list || list.length === 0) {
        setSubjects([]);
         dispatch(setSubjects([]));
        return;
      }
dispatch(setSelectedSubject(null)); // Reset selected subject on program change
       const mappedSubjects: SubjectOption[] = [
      {
        label: "Select All",
        data: "ALL",
        selected: selectedSubject===null ? false : true,  // ✅ default selected
      },
      ...list.map((s: SubjectList) => ({
        label: s.course_title,
        data: s,          // ✅ store full subject object
        selected: false,  // individual unchecked
      })),
    ];
// ✅ GOOD
setSubjects([...mappedSubjects]);

dispatch(setSubjects(mappedSubjects));
    Logger.info("Subjects List:", mappedSubjects);  
    },
  });
};

const toggleSubject = (index: number) => {
  // Select All
  if (index === 0) {
    const isSelected = !subjects[0].selected;

    dispatch(
      setSubjects(
        subjects.map(s => ({ ...s, selected: isSelected }))
      )
    );
    return;
  }

  // Individual multi-select
  const updatedSubjects = subjects.map((s, i) => {
    if (i === index) {
      return { ...s, selected: !s.selected };
    }
    return s;
  });

  // Auto update "Select All"
  const allSelected = updatedSubjects
    .slice(1)
    .every(s => s.selected);

  updatedSubjects[0] = {
    ...updatedSubjects[0],
    selected: allSelected,
  };

  dispatch(setSubjects(updatedSubjects));
  Logger.info("Toggled Subjects:", updatedSubjects);
};

const isSelectAll = () => {
  if (!subjects || subjects.length === 0) return true;

  // ignore index 0 (Select All)
  return subjects.slice(1).every((s) => s.selected);
};
const getSelectedCourseId = (): string | null => {
  const selected = subjects.find(
    (s) => s.selected && s.data !== "ALL"
  );

  if (!selected || selected.data === "ALL") return null;

  return selected.data.course_id;
};




const getList = () =>
  !activeTab || activeTab === "program"
    ? gradedProgram ?? []
    : industries;
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "10px",
        padding: "16px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        minWidth: getList().length === 0 ? "150px" : "500px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {/* Main content */}
      <div style={{ display: "flex", justifyContent: "space-between",height:"350px" }}>
        {/* Tabs */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            minWidth: "120px",
            height:"350px", overflowY:"auto"
          }}
        >
        {heading!="Industry Performance"&&(  <div
            onClick={() => {
              dispatch(setActiveTab("program"));
            }}
            style={{
              padding: "4px",
              borderRadius: "6px",
              cursor: "pointer",
              background: activeTab === "program" ? "#F2F4F7" : "transparent",
            }}
          >
            Program
          </div>)}
        </div>

        {/* Divider */}
        {gradedProgram.length > 0 && (
          <div style={{ borderLeft: "1px solid #E0E0E0", margin: "0 16px" }} />
        )}

        {/* Assessment list */}
       {gradedProgram && gradedProgram.length > 0 ? (
  <div   className="thin-scroll"
 style={{ display: "flex", flexDirection: "column", gap: "8px" ,height:"350px", overflowY:"auto"}}>
    {gradedProgram.map((program, idx) => (
      <div
        key={idx}
        onClick={() => onProgramClick(program)}
        style={{
          fontSize: "14px",
          color: "#101828",
          padding: "6px",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight:400,
          paddingRight:"0px",
          background: selectedProgram?.program_id === program.program_id ? "#F2F4F7" : "transparent",
        }}
      >
        {program.program_title}
      </div>
    ))}
  </div>
) : (
  <div style={{ color: "#667085", fontSize: "14px" }}>No Programs found</div>
)}

         {getList().length > 0 && (
          <div style={{ borderLeft: "1px solid #E0E0E0", margin: "0 16px" }} />
        )}

        {/* Assessment list */}
        {subjects.length > 0 ? (
          <div   className="thin-scroll"
 style={{ marginTop: "0px",      height:"350px", overflowY:"auto",overflowX: "hidden",
 }}>
    {/* <div style={{ fontWeight: 600, marginBottom: "6px" }}>Subjects</div> */}

    {subjects.map((item, idx) => (
  <label
    key={item.label
    }
    style={{
      display: "flex",
      width: "100%",         
    boxSizing: "border-box",
    wordBreak: "break-word",
      alignItems: "center",
      gap: "8px",
      padding: "6px",
      cursor: "pointer",
      // background:
      //   item.selected
      //     ? "#F2F4F7"
      //     : "transparent",
      borderRadius: "6px",
      fontSize:"14px",
      color:"#101828",
    }}
  >
 <Form.Check      type="checkbox"
      checked={item.selected}
      onChange={() => toggleSubject(idx)}
                            className="custom-checkbox-label"
                            style={{color:"#101828"}}

    />
    {item.label}
  </label>
))}

  </div>

        ) : (
          <div style={{ color: "#667085", fontSize: "14px" }}>
            No Subjects found
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
          paddingTop: "12px",
        }}
      >
        <button
          style={{
            background: "transparent",
            border: "none",
            color: "#344054",
            cursor: "pointer",
          }}
          onClick={() => {
dispatch(setSelectedSubject(null));

  dispatch(
    setSubjects(
      subjects.map((item) => ({
        ...item,
        selected: false,
      }))
    )
  );setresetGP((prev: any) => !prev); // ✅ always triggers
           
          }}
        >
          Reset
        </button>
        <button
          style={{
            background:
              !getSelectedCourseId()
                ? "#E0E0E0"
                : "#FDB022",
            border: "none",
            borderRadius: "8px",
            padding: "6px 16px",
            fontWeight: 500,
            cursor:
             !getSelectedCourseId()
                ? "not-allowed"
                : "pointer",
            color: "#101828",
          }}
onClick={() => {
  onView(
    selectedProgram?.program_id || "", 
    isSelectAll(),  
        subjects,                  
    getSelectedCourseId()             
  );
}}
  disabled={!getSelectedCourseId()} // ✅ FIXED
        >
          View
        </button>
      </div>
    </div>
  );
};

export default AdvancedFilterGradedPopQuiz;
